export const AllRoleListSuccess = 'ALL_ROLE_LIST_SUCCESS';
export const RoleListSuccess = 'ROLE_LIST_SUCCESS';

export function setAllRoleListAction(data) {
  return {
    type: AllRoleListSuccess,
    payload: data,
  };
}

export function setRoleListAction(data) {
  return {
    type: RoleListSuccess,
    payload: data,
  };
}
